import React, { useState, useEffect, useCallback, useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import CachedIcon from '@material-ui/icons/Cached';
import { QuickAppointmentContext } from '../../Context';
import { apiGet } from '../../brainApi';
import useStyles from '../styles';

const Services = () => {
  const [setService, setServices] = useState(null);
  const [loading, setLoading] = useState(false);
  const { serviceData } = useContext(QuickAppointmentContext);

  const getServices = useCallback(() => {
    setLoading(true);
    apiGet('/service-offering').then((json) => {
      if (json.length > 0) {
        const selected_service_offering_ids = serviceData?.newServices.map(
          (s) => s.service_offering_id,
        );
        const services = json.filter((service) =>
          selected_service_offering_ids?.includes(service.service_offering_id),
        );
        setServices(services);
        setLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    getServices();
  }, [getServices]);

  const classes = useStyles();
  return (
    <div className={classes.main}>
      {loading ? (
        <CachedIcon className={classes.fieldIcon} />
      ) : (
        setService &&
        setService.map((service) => (
          <Typography
            className={classes.typography}
            variant="caption"
            key={service.service_offering_ids}
          >
            {service.short_name}
          </Typography>
        ))
      )}
    </div>
  );
};

export default Services;
